import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { CompanyDocuments } from 'api';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { useDocuments } from 'services/hooks';
import DocumentGenerationJobPageHeader from './components/DocumentGenerationJobPageHeader/DocumentGenerationJobPageHeader';
import DocumentGenerationJobsTable from './components/DocumentGenerationJobTable/DocumentGenerationJobTable';

const DocumentGenerationJobs = () => {
  // any because companyInfo is not strongly typed
  const [storeValue] = useStore() as unknown as UseStoreValues;
  const { companyInfo } = storeValue;
  const { getDocuments, companyDocuments } = useDocuments() as unknown as {
    getDocuments: (companyId: number, measurementDataId: number) => Promise<void>;
    companyDocuments: CompanyDocuments[] | undefined;
  };

  useEffect(() => {
    if (companyInfo?.id) {
      getDocuments(companyInfo.id as number, companyInfo.measurement_data_id as number);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo?.id]);

  if (!companyInfo?.id)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );

  const hasDocuments = companyDocuments === undefined || companyDocuments.length > 0;

  return (
    <div>
      <DocumentGenerationJobPageHeader showCreateButton={hasDocuments} />
      <DocumentGenerationJobsTable companyDocuments={companyDocuments} />
    </div>
  );
};

export default DocumentGenerationJobs;
